/* @flow */

export const FETCH_MANUAL_AVAILABILITIES_REQUEST =
  'FETCH_MANUAL_AVAILABILITIES_REQUEST';
export const FETCH_MANUAL_AVAILABILITIES_FAILURE =
  'FETCH_MANUAL_AVAILABILITIES_FAILURE';
export const FETCH_MANUAL_AVAILABILITIES_SUCCESS =
  'FETCH_MANUAL_AVAILABILITIES_SUCCESS';

export const SIMULATE_MANUAL_AVAILABILITIES_FETCH =
  'SIMULATE_MANUAL_AVAILABILITIES_FETCH';

export const ADD_MANUAL_AVAILABILITY_REQUEST =
  'ADD_MANUAL_AVAILABILITY_REQUEST';
export const ADD_MANUAL_AVAILABILITY_FAILURE =
  'ADD_MANUAL_AVAILABILITY_FAILURE';
export const ADD_MANUAL_AVAILABILITY_SUCCESS =
  'ADD_MANUAL_AVAILABILITY_SUCCESS';
export const ADD_MANUAL_AVAILABILITY_OPTIMISTICALLY_REQUEST =
  'ADD_MANUAL_AVAILABILITY_OPTIMISTICALLY_REQUEST';

export const DELETE_MANUAL_AVAILABILITY_REQUEST =
  'DELETE_MANUAL_AVAILABILITY_REQUEST';
export const DELETE_MANUAL_AVAILABILITY_FAILURE =
  'DELETE_MANUAL_AVAILABILITY_FAILURE';
export const DELETE_MANUAL_AVAILABILITY_SUCCESS =
  'DELETE_MANUAL_AVAILABILITY_SUCCESS';
export const DELETE_MANUAL_AVAILABILITY_OPTIMISTICALLY_REQUEST =
  'DELETE_MANUAL_AVAILABILITY_OPTIMISTICALLY_REQUEST';
export const DELETE_ALL_MANUAL_AVAILABILITY_OPTIMISTICALLY_REQUEST =
  'DELETE_ALL_MANUAL_AVAILABILITY_OPTIMISTICALLY_REQUEST';
